class FhomeRadioResourceUsersController {
  static controller($rootScope, $sce, $scope, $state, ResourceService, $mdSidenav, $base64, $localStorage) {
    'ngInject';

    let currentResource = ResourceService.getCurrentResource();
    console.log('$scope.currentResource', $scope.currentResource);
    let userLogin = $base64.decode($localStorage.loggedUser.login);

    // var env = require('.env');
    console.log('ENV', process.env);

    let resourcePath = process.env.RESOURCE_APPS_ROOT_URL + '/fhome-radio/#/init-cloud-resource?resource-uuid='
                        + currentResource.uniqueId
                        + '&cloud-account-email='
                        + userLogin
                        + '&lang='
                        + localStorage['lang'];

    $scope.resourceUrl = $sce.trustAsResourceUrl(resourcePath)
    
    systemStatus();
    function systemStatus(){
      var promise = ResourceService.systemStatus();
      
      promise.then(function(data) {
        console.log('sytsemStatus ok', data);
        $scope.systemStatus = data.response;
      });
    };

  };
}

export default FhomeRadioResourceUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/resource/fhomeradio.resource.users.controller.js